import React, { useEffect, useState, useRef } from "react";
import Navbar from "react-bootstrap/Navbar";
import { Container, Stack, Row, Col } from "react-bootstrap";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "../components/SignInButton";
import { SignOutButton } from "../components/SignOutButton";
import axios from "../configuration/axios";
import { useMsal } from "@azure/msal-react";
import FirstComeSelection from "../components/FirstComeSelection";
import SubscriptionDetails from "../components/SubscriptionDetails";
import CreateLicenseDialog from "../components/CreateLicenseDialog";
import LicenseCard from "../components/LicenseCard";
import ExceptionDialog from "../components/ExceptionDialog";
import BuyLicensesComponent from "../components/BuyLicensesComponent";
import { HasDeactivatedLicenseDialog } from "../components/HasDeactivatedLicenseDialog";
import { LicenseConfirmationPopUp } from "../components/LicenseConfirmationPopUp";
import { Text } from "@fluentui/react";
import { ExpiredTokenPopup } from "../components/ExpiredTokenPopup";

function LicenseMangementPage(props) {
  const { setTokenExpired, tokenExpired, hasAdminSignedInAndSubscription } =
    props;
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [isActivating, setIsActivating] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isProvisioned, setIsProvisioned] = useState(false);
  const [userSignedIn, setUserSignedIn] = useState(false);
  const [isFirstCome, setIsFirstCome] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState({});
  const [token, setToken] = useState(null);
  const [licenses, setLicenses] = useState([]);
  const [showExceptionDialog, setShowExceptionDialog] = useState(false);
  const [exceptionMessage, setExceptionMessage] = useState("");
  const [
    showHasDeactivatedLicensesDialog,
    setShowHasDeactivatedLicensesDialog,
  ] = useState(null);

  const [popUp, setPopUp] = useState(false);
  const [toDeleteLicenseData, setToDeleteLicenseData] = useState();

  let authMsalToken = localStorage.getItem("msalToken");

  useEffect(async () => {
    setToken(localStorage.getItem("msalToken"));
    await getSubscriptionData();
  }, [
    token,
    accounts,
    subscriptionData != null,
    showHasDeactivatedLicensesDialog != null,
  ]);

  function addLicenseToList(licenseToAdd) {
    const newLicensesState = [...licenses];
    newLicensesState.push(licenseToAdd);
    setLicenses(newLicensesState);
  }

  async function removeLicense(licenseId) {
    var newLicenseList = [...licenses];
    for (var i = newLicenseList.length - 1; i >= 0; i--) {
      if (newLicenseList[i].licenseId === licenseId) {
        newLicenseList.splice(i, 1);
      }
    }
    setLicenses(newLicenseList);
  }

  async function updateLicense(licenseData) {
    var newLicenseList = [...licenses];
    for (var i = newLicenseList.length - 1; i >= 0; i--) {
      if (newLicenseList[i].licenseId === licenseData.licenseId) {
        newLicenseList[i] = licenseData;
      }
    }
    setLicenses(newLicenseList);
  }

  async function setFirstComeFirstServe(isEnabled) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
      },
    };
    const bodyParameters = {
      tenantId: accounts[0].tenantId,
      isEnabled: isEnabled,
    };

    await axios
      .post(
        axios.defaults.baseURL + "/Subscription/SetFirstCome",
        bodyParameters,
        config
      )
      .then((result) => {
        setTokenExpired(false);
        setIsFirstCome(result.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setTokenExpired(true);
        }
      });
  }

  async function getSubscriptionData() {
    if (accounts.length > 0) {
      var resultData;
      var tenantId = accounts[0].tenantId;
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      await axios
        .get(
          axios.defaults.baseURL + "/Subscription/GetByTenantId",
          { params: { tenantId: tenantId } }
        )
        .then((result) => {
          setTokenExpired(false);
          setSubscriptionData(result.data);
          setIsFirstCome(result.data.isFirstComeFirstServe);
          resultData = result.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            setTokenExpired(true);
          }
        });
      if (resultData) {
        await getLicenseList(resultData);
        await checkDeactivatedLicenses(resultData);
      }
    }
  }

  async function getLicenseList(resultData) {
    if (resultData.id) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      await axios
        .get(
          axios.defaults.baseURL + "/License/AllLicensesForSubscription",
          { params: { subscriptionId: resultData.id } }
        )
        .then((result) => {
          setTokenExpired(false);
          setLicenses(result.data);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            setTokenExpired(true);
          }
        });
    }
  }

  async function checkDeactivatedLicenses(resultData) {
    if (resultData.id) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      await axios
        .get(
          axios.defaults.baseURL + "/License/CheckDeactivatedLicenses",
          { params: { subscriptionId: resultData.id } }
        )
        .then((result) => {
          setTokenExpired(false);
          setShowHasDeactivatedLicensesDialog(result.data);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            setTokenExpired(true);
          }
        });
    }
  }

  async function removeLicenseById(licenseData) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
      },
    };
    var resData;
    await axios
      .delete(
        axios.defaults.baseURL+ "/License/DeleteById",
        { params: { licenseId: licenseData.licenseId } },
        config
      )
      .then((result) => {
        setTokenExpired(false);
        removeLicense(licenseData.licenseId);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setTokenExpired(true);
        }
      });
  }
  document.body.style.overflow = "hidden"
  return (
    <div>
      {tokenExpired && isAuthenticated ? <ExpiredTokenPopup setTokenExpired={setTokenExpired} />: null}
      <Navbar
        style={{
          paddingBottom: "0.5vh",
          justifyContent: "left",
          borderBottom: "2px",
          borderColor: "black",
          backgroundColor: "#0066CC",
        }}
        variant="dark"
      >
        <a className="navbar-brand" href="/" style={{ marginLeft: "1rem" }}>
          novaCapta Compass Subscription Management
        </a>
        {isAuthenticated ? (
          <SignOutButton setTokenExpired={setTokenExpired} />
        ) : (
          <SignInButton setUserSignedIn={setUserSignedIn} />
        )}
      </Navbar>
      {hasAdminSignedInAndSubscription ? (
        <div style={{ marginLeft: "3rem" }}>
          <h5 style={{ marginTop: "2vh" }}>
            <p style={{ fontSize: "3vh", fontWeight:"700", margin: "0" }}>License Management</p>
            <p style={{ marginTop: "2vh", marginBottom:"0.5vh", fontSize: "2vh" }}>Your subscription</p>
            <Stack>
              <Container fluid>
                <Row style={{flexWrap: "nowrap"}}>
                  <Col>
                    <FirstComeSelection
                      setFirstComeFirstServe={setFirstComeFirstServe}
                      isFirstCome={isFirstCome}
                    />
                  </Col>
                  <Col
                    xl={10}
                    style={{ disply: "flex", justifyContent: "left", flexShrink: "1" }}
                  >
                    <BuyLicensesComponent
                    setTokenExpired={setTokenExpired}
                      subscriptionId={subscriptionData.id}
                    />
                  </Col>
                </Row>
                <Row>
                  <SubscriptionDetails subscriptionData={subscriptionData} />
                </Row>
              </Container>
            </Stack>
            <div style={{ marginTop: "3vh" }}>
              <Container fluid>
                <Row>
                  <Col>
                    <CreateLicenseDialog
                    setTokenExpired={setTokenExpired}
                      addLicenseToList={addLicenseToList}
                      subscriptionId={subscriptionData.id}
                      setShowExceptionDialog={setShowExceptionDialog}
                      setExceptionMessage={setExceptionMessage}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
            <Stack style={{overflowY: "scroll",overflowX: "hidden", height:"56vh", marginTop:"2vh"}}>
              {licenses.map(function (license) {
                return (
                  <div>
                    <LicenseCard
                    setTokenExpired={setTokenExpired}
                      licenseData={license}
                      updateLicense={updateLicense}
                      removeLicense={removeLicense}
                      setShowExceptionDialog={setShowExceptionDialog}
                      setExceptionMessage={setExceptionMessage}
                      setPopUp={setPopUp}
                      setToDeleteLicenseData={setToDeleteLicenseData}
                    />
                  </div>
                );
              })}
            </Stack>
            <ExceptionDialog
              showExceptionDialog={showExceptionDialog}
              setShowExceptionDialog={setShowExceptionDialog}
              exceptionMessage={exceptionMessage}
            />
            <HasDeactivatedLicenseDialog
              showHasDeactivatedLicensesDialog={
                showHasDeactivatedLicensesDialog
              }
              setShowHasDeactivatedLicensesDialog={
                setShowHasDeactivatedLicensesDialog
              }
            />
          </h5>
        </div>
      ) : null}
      <Navbar
        style={{
          justifyContent: "center",
          marginTop: "3.5rem",
          borderColor: "black",
          backgroundColor: "#0066CC",
          position: "absolute",
          bottom: "0",
          width: "100vw"
        }}
        variant="dark"
      >
        <Text style={{ color: "white" }}>©2021 novaCapta GmbH</Text>
      </Navbar>
      {popUp ? (
        <LicenseConfirmationPopUp
          setPopUp={setPopUp}
          removeLicenseById={removeLicenseById}
          toDeleteLicenseData={toDeleteLicenseData}
        />
      ) : null}
    </div>
  );
}

export default LicenseMangementPage;
